import useTitle from 'hooks/useTitle';
import React from 'react';
import Accordion from '../../../../../../../components/Accordion/Accordion';

const Monthly = () => {
  useTitle("گزارش های ماهانه")
  return (
    <Accordion title="عملکرد این ماه" open>
      Monthly ...
    </Accordion>
  );
};

export default Monthly;
